import { SeeDepositProps } from './props';
import { Button } from '@starsoft/common/components';
import { useModalNavigation, useTranslation } from '@starsoft/common/hooks';
import { CommonModalsKey, DepositStep } from '@starsoft/common/enums';

/**
 * SeeDeposit Component
 * A button component that allows viewing deposit details in a modal.
 * Uses translation and modal navigation hooks to handle the UI and routing.
 *
 * @component
 * @param {Object} props - Component props
 * @param {DepositType} props.deposit - The deposit data object containing details like ID and method
 * @returns {JSX.Element} A tiny button that opens the deposit details modal when clicked
 *
 * @example
 * const deposit = {
 *   id: "d123",
 *   method: {
 *     id: "m456"
 *   }
 * };
 *
 * <SeeDeposit deposit={deposit} />
 */
export function SeeDeposit({ deposit }: SeeDepositProps) {
  const { t } = useTranslation('data-grid');
  const { navigateToModal } = useModalNavigation();

  /**
   * Handles the button click event
   * Navigates to the deposit modal with the specific deposit ID and method ID
   * @returns {void}
   */
  function onClick() {
    navigateToModal(
      CommonModalsKey.Deposit,
      `?step=${DepositStep.Response}&deposit-id=${deposit?.id}&method-id=${deposit?.method?.id}`,
    );
  }

  return (
    <Button isTiny onClick={onClick}>
      {t('see')}
    </Button>
  );
}
